var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVacationCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_2_2571)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2571",
    x1: 74.55,
    y1: 0.00000214197,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFFF6"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVacationCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vacation_circle.20f72b7e16a6fb0658dc855b50f5716e.svg";